var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63592 0.800177C8.77808 0.487723 9.22192 0.487722 9.36408 0.800176L11.704 5.9428C11.7622 6.07077 11.8833 6.15877 12.023 6.1746L17.637 6.81083C17.9781 6.84949 18.1153 7.2716 17.8621 7.50336L13.6942 11.3179C13.5905 11.4128 13.5442 11.5552 13.5723 11.693L14.7021 17.2288C14.7707 17.5652 14.4116 17.826 14.113 17.6568L9.19718 14.8717C9.07486 14.8024 8.92514 14.8024 8.80282 14.8717L3.88703 17.6568C3.58836 17.826 3.22929 17.5652 3.29793 17.2288L4.42766 11.693C4.45577 11.5552 4.4095 11.4128 4.30579 11.3179L0.13794 7.50336C-0.115289 7.2716 0.0218625 6.84949 0.362956 6.81083L5.97696 6.1746C6.11665 6.15877 6.23778 6.07077 6.296 5.9428L8.63592 0.800177Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4f3881299fdd7641d6236854008030e3.svg";
export { ForwardRef as ReactComponent };